import type { IAttributes, IDirective } from "angular";
import { module } from "angular";

import { InputDirectiveFunctions } from "App/Modules/Gui/Directives";
import "./InputPasswordDirective.scss";

export default class InputPasswordDirective implements IDirective {
    public priority = 1000;

    public restrict = "E";

    public scope = {
        irLabel: "<",
        ngModel: "=",
    };

    public template: string;

    public inputType: string;

    public compile = InputDirectiveFunctions.compile(this.link); // eslint-disable-line @typescript-eslint/unbound-method

    constructor() {
        this.template = `
                <i title="{{'Entities.Password.HideShowPassword' | translate}}"
                    class="fal fa-eye pull-right toggle-password"></i>
                <input class="input-pass form-control" type="password"
                    aa-field-group="ngModel" aa-label="{{irLabel | translate}}" />
                `;
    }

    public link(
        scope: any,
        instanceElement: JQuery,
        instanceAttributes: IAttributes,
        controller: any,
        transclude?: any,
    ) {
        InputDirectiveFunctions.link(scope, instanceElement, instanceAttributes, controller, transclude);

        const $toggleBtn = instanceElement.find(".toggle-password");
        const $inputPass = instanceElement.find(".input-pass");
        const inputPass = $inputPass[0] as HTMLInputElement;
        // IE 11 fix
        this.inputType = "";

        $toggleBtn.on("click", () => {
            inputPass.type = this.inputType;
            if (inputPass.type === "password") {
                this.inputType = "text";
                $toggleBtn.removeClass("fa-eye-slash");
                $toggleBtn.addClass("fa-eye");
            } else {
                this.inputType = "password";
                $toggleBtn.removeClass("fa-eye");
                $toggleBtn.addClass("fa-eye-slash");
            }
        });
    }
}

module("mmGui").directive("irInputPassword", () => new InputPasswordDirective());
